import RequestTwoVerification from '../../components/auth/RequestTwoVerification';

const RequestTwoVerificationPage = () => {
  return <RequestTwoVerification />;
};

export default RequestTwoVerificationPage;